/**
 * Маска российского телефона для полей [data-phone-mask]:
 * +7 (XXX) XXX-XX-XX. Значение отдаётся как есть, нормализует сервер.
 */
function format( digits ) {

    if( digits.startsWith('8') )
        digits = '7' + digits.slice( 1 );

    if( ! digits.startsWith('7') )
        digits = '7' + digits;

    digits = digits.slice( 0, 11 );

    let out = '+7';

    if( digits.length > 1 )
        out += ' (' + digits.slice( 1, 4 );

    if( digits.length >= 4 )
        out += ') ' + digits.slice( 4, 7 );

    if( digits.length >= 7 )
        out += '-' + digits.slice( 7, 9 );

    if( digits.length >= 9 )
        out += '-' + digits.slice( 9, 11 );

    return out;
}

export function phoneMask( root = document ) {

    root.querySelectorAll('[data-phone-mask]').forEach( ( input ) => {

        if( input.dataset.masked )
            return;

        input.dataset.masked = '1';

        input.addEventListener( 'input', () => {

            const digits = input.value.replace( /\D/g, '' );

            input.value = digits === '' ? '' : format( digits );
        } );

        if( input.value )
            input.dispatchEvent( new Event('input') );
    } );
}
